export enum SUMType {
  CONTAINER = "container",
  PDF = "pdf",
  HTML = "html",
}

export interface SumConfigItem {
  type: SUMType.PDF | SUMType.HTML;
  name: string;
  href: string;
}

export interface SumConfigContainer {}

export type SUMConfig = {
  type: SUMType;
  name: string;
  href?: string;
  items?: SumConfigItem[];
};

export type SUMTreeNodeData = SUMConfig & {
  id: string;
};
